import * as mutationTypes from "../store/mutation-types";
import userNotificationsHelper from "./userNotificationsHelper";
import ProductSelection from "../domains2/orders/ProductSelection";
import {generateProductCatalog} from "./ProductCatalogHelpers";
import { DeliveryMethodsEnum } from "../domains2/libraries/DeliveryMethods";
import { pushNotificationSubscription } from "../libraries/utils";
import mutationTypesTid6 from "../store/tenantSpecificModules/storeModulesTid6/mutationTypesTid6";
import routeMapper from "../router/routeMapper";
import { pushGTMInternal } from "../integrations/tracking/gtm/pushGtmEvents";

const isCatalogDefined = (store) => ((store.getters.productCatalog || {}).products || []).length;
const isShopDefined = (store) => (store.getters.globalSelectedShop || {}).id;
const isDeliveryChoiceDefined = (store) => (store.getters.tenantSpecificData || {}).deliveryChoice;
const isSameShop = (store, shopId) => shopId === (store.getters.globalSelectedShop || {}).id;
const isSameDeliveryChoice = (store, deliveryChoice) => deliveryChoice === (store.getters.tenantSpecificData || {}).deliveryChoice;

export const onPushNotificationActionPerformedCallback  = async (router, store, obj) => {
	if (!obj || !obj.notification || !obj.notification.data) {
		return;
	}
	const {postOrderDiscount} = ((obj || {}).notification || {}).data || {};
	if (postOrderDiscount) {
		// handles PN sent by our backend system, after order is purchased - using firebase admin sdk
		const {shopId, deliveryChoice, productId, voucherCode, campaignName, trackOpened, discountedPrice} = (typeof postOrderDiscount === "string" ? JSON.parse(postOrderDiscount) : postOrderDiscount) || {};
		if (!shopId || !Object.values(DeliveryMethodsEnum).includes(deliveryChoice) || !productId) {
			return;
		}

		if (trackOpened) {
			pushGTMInternal(
				"ppd_opened",
				router.path,
				router.path,
				"",
				{
					campaignName
				}
			);
		}
		const goToCheckout = (router, store, {postOrderDiscountFlowWithCatalogLoading} = {}) => {
			const enableThreeStepFullscreenCheckoutMobile = store.getters.featureToggles.enableThreeStepFullscreenCheckoutMobile;
			const cartRoute = enableThreeStepFullscreenCheckoutMobile ? routeMapper.routeNames.fullBasketCheckout : routeMapper.routeNames.checkoutCart;
			const activeStep = enableThreeStepFullscreenCheckoutMobile ? 2 : undefined;
			router.push({
				name: cartRoute,
				params: {
					postOrderDiscountFlowWithCatalogLoading,
					activeStep,
					voucherCode,
					...(trackOpened ? {
						trackPPDConverted: true,
						campaignName,
						discountedPrice
					}: {})
				}
			});
		};
		const addProductToCart = async () => {
			const ps = ProductSelection.createFromProduct(store.getters.productCatalog.getProduct(productId));
			await store.dispatch(mutationTypes.ADD_PRODUCT_SELECTION_TO_CART, {
				...ps,
				quantity: 1
			});
			return ps;
		};
		const addPpdProductSelectionToStore = (store, ps) => {
			const ppdProductSelectionIds = [...store.getters.ppdProductSelectionIds, ps.productSelectionId];
			store.commit(mutationTypes.POST_PURCHASE_DISCOUNT_PRODUCT_SELECTIONS, ppdProductSelectionIds);
		};
		if (isCatalogDefined(store) && isDeliveryChoiceDefined(store) && isShopDefined(store)) {
			if (isSameShop(store, shopId) && isSameDeliveryChoice(store, deliveryChoice)) {
				const ps = await addProductToCart();
				goToCheckout(router, store, {postOrderDiscountFlowWithCatalogLoading: false});
				addPpdProductSelectionToStore(store, ps);
				return;
			} else {
				// is custom logic needed when shop id or delivery choice differs? (shall we forget current cart selection and create new catalog in shop defined in PN, and reset the cart)
			}
		} else {
			store.commit(mutationTypes.SHOW_LOADER_AFTER_PPD_CATALOG_CREATION, true);
			await generateProductCatalog(shopId, deliveryChoice, store);
			const ps = await addProductToCart();
			goToCheckout(router, store, {postOrderDiscountFlowWithCatalogLoading: true});
			addPpdProductSelectionToStore(store, ps);
			store.commit(mutationTypes.SHOW_LOADER_AFTER_PPD_CATALOG_CREATION, false);
		}
	} else {
		// handles PN sent by Sunset - from firebase or however they do it
		userNotificationsHelper.createUserNotificationOnPushNotificationTap(router, obj);
	}
};

export const onPushNotificationReceivedCallback = (self, notification) => {
	const {postOrderDiscount} = (notification || {}).data || {};
	if (postOrderDiscount) {
		const {campaignName, trackReceived} = (typeof postOrderDiscount === "string" ? JSON.parse(postOrderDiscount) : postOrderDiscount) || {};

		if (trackReceived) {
			pushGTMInternal(
				"ppd_received",
				self.$route.path,
				self.$route.path,
				"",
				{
					campaignName
				}
			);
		}
	}
	if(notification.data.from && typeof notification.data.from === "string" && notification.data.from.includes("topic")) {
		// at the moment of writing this code value looked like /topics/topic_name
		const topicName = notification.data.from.replace("/topics/", "");
		pushNotificationSubscription({topic: topicName, unsubscribe: true});
		// remove gift in basket notification limit after you receive message
		self.$store.commit(mutationTypesTid6.REMOVE_FIREBASE_SUBSCRIPTION, "punchCardComplete");
	}
	userNotificationsHelper.createUserNotification(notification);
};
